import { useSelector, useDispatch } from "react-redux";
import type { RootState } from "../redux/store";
import { createSlice } from "@reduxjs/toolkit";

// Slice definition
const userNameSlice = createSlice({
	name: "userName",
	initialState: null as string | null,
	reducers: {
		setUserName: (_state, action: { payload: string | null }) => action.payload,
	},
});

export const { setUserName: setUserNameAction } = userNameSlice.actions;
export const userNameReducer = userNameSlice.reducer;

export function useUserName(): string | null {
	return useSelector((state: RootState) => state.userName);
}

export function useSetUserName() {
	const dispatch = useDispatch();
	return (userName: string | null) => {
		dispatch(setUserNameAction(userName));
	};
}
